
import { mapState, mapGetters } from 'vuex'

export default {
  props: ['likes', 'graduateid'],
  computed: {
    ...mapState({
      authUser: (state) => state.authUser,
    }),
    ...mapGetters({
      isLoggedIn: 'isLoggedIn',
    }),
    liked() {
      return this.likes?.some((element) => {
        if (element.ids.includes(this.graduateid)) {
          //TODO change the following line to get custom olor from wishlist
          return element.hex || 'red'
        }
      })
    },
    colour() {
      return this.likes.find((list) => {
        return list.ids.includes(this.graduateid)
      }).hex
    },
  },
  methods: {
    newList(list) {
      this.likes.push(list)
    },
    toggleLike(list, index) {
      this.index = index
      this.$emit('toggleLike', { id: this.graduateid, name: list })
    },
  },
  data() {
    return {
      menu: false,
      index: null,
    }
  },
}
